import { TrainSHomeStoreCtx } from '@/stores/TrainStore/TrainSHomeStore';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

import styles from './TrainSHomeJourneyType.module.scss';

const TrainSHomeJourneyType: React.FC = () => {
  const store = useContext(TrainSHomeStoreCtx);

  return (
    <section className={styles.container}>
      <button
        className={clsx(styles.type, !store.IsRoundTrip && styles.active)}
        onClick={() => store.setJourneyType('ONEWAY')}
      >
        편도
      </button>
      <button
        className={clsx(styles.type, store.IsRoundTrip && styles.active)}
        onClick={() => store.setJourneyType('ROUND')}
      >
        왕복
      </button>
    </section>
  );
};

export default observer(TrainSHomeJourneyType);
